<template>
  <div class="iv-new-show">
    <div class="iv-show-each" v-for="keyItem in objectKeys" :key="map[keyItem]">
      <p class="iv-show-title"><span>{{map[keyItem]}}</span><span @click="goToList(keyItem, map[keyItem])" class="iv-pointer">...</span></p>
      <div >
        <p class="iv-list-li" @click="toDetail(i, map[keyItem])" v-for="i in showList[keyItem]" :key="i.infoId">
          <span></span>
          <span :title="'['+i.orgName+']'+i.title">[{{ i.orgName }}] {{i.title}}</span>
<!--          <span class="toTop"></span>-->
          <span class="toTop" v-show="i.top>0"></span>
          <span>{{getTime(i.publishTime)}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import Iconfont from '@/components/iconfont'

export default {
  data () {
    return {
      objectKeys: [],
      showList: {},
      map: {
        party_lead: '党建引领',
        probity_garden: '廉洁园地',
        culture_position: '文化阵地',
        union_news: '工会动态',
        youth_league_voice: '青团之声',
        notice: '通知公告',
        model_strength: '榜样力量',
        pioneer_innovation: '管理者思想'
        // TODO PM确认后删除注释内容
        // notice: '通知公告',
        // party_lead: '党建引领',
        // probity_garden: '廉洁园地',
        // union_news: '工会动态',
        // youth_league_voice: '青团之声',
        // pioneer_innovation: '创业创新',
        // culture_position: '文化阵地',
        // model_strength: '榜样力量',

      },
      navMap: {}
    }
  },
  props: ['navData'],
  created () {
    this.navMap=this.navData
    this.getmanagerThought()
  },
  watch: {
    navData (val) {
      this.navMap = val
    }
  },
  methods: {
    goToList (code, name) {
      const { href } = this.$router.resolve({
        name: code,
        query: {
          categoryCode: code,
          categoryName: name,
          categoryId: this.navMap[code].categoryId,
          categoryType: this.navMap[code].categoryType
        }
      })
      window.open(href, '_blank')
    },
    getmanagerThought () {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'party_lead,probity_garden,culture_position,union_news,youth_league_voice,notice,model_strength,pioneer_innovation',
          rowNum: '5'
        }
      }).then(({data}) => {
        this.showList = data.data
        this.objectKeys = Object.keys(this.map)
        // this.objectKeys = Object.keys(this.showList)
      })
    },
    getTime (d) {
      return timeFormat(d)
    },
    toDetail (item, name) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          infoId: item.id,
          categoryName: name
          // categoryName:item.columnName

        }
      })
      window.open(href, '_blank')
    }
  },
  components: {
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.iv-list-li {
  cursor: pointer;
  .iv-zd {
    color: #FA2900;
  }
}
.iv-new-show {
  margin-top: 24px;
  margin-bottom: 80px;
  display: flex;
  gap: 66px;
  flex-wrap: wrap;
  .iv-show-each {
    //padding-right: 40px;
    width: calc(33% - 40px);
    height: 336px;
    .iv-show-title {
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      width: 100%;
      height: 71px;
      span:nth-of-type(1) {
        float: left;
        height: 68px;
        font-size: 30px;
        font-family:"Microsoft YaHei";
        // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 68px;
        border-top: 2px solid #FFC757;;
      }
      span:nth-of-type(2) {
        float: right;
        height: 4px;
        font-size: 30px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 6px;
      }
    }
    .toTop {
      background: url("~@/assets/images/icon-top.png") no-repeat;
      background-size: 18px;
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
    div {
      //margin-bottom: 16px;
      //height: 48px;
      p {
        position: relative;
        display: flex;
        border-bottom: 1px dashed rgba(0, 0, 0, 0.16);
        align-items: center;
        span:nth-of-type(1) {
          width: 6px;
          height: 6px;
          background: #FFC757;
          border-radius: 3px;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        span:nth-of-type(2) {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          flex:1;
          height: 48px;
          line-height: 48px;
          margin-left: 16px;
          margin-right: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        span:nth-of-type(4) {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          width: 85px;
          height: 48px;
          line-height: 48px;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }
  .iv-show-each:nth-of-type(3n) {
    //margin-right: 0px;
  }
}
</style>
